import { Flex, Text, TextField, Select } from '@radix-ui/themes'
import { RedemptionLimitFrequencyPeriod } from '@Generated/back-office-client/src'
import { DateInput } from '../components/date-input'
import { LIMIT_PERIOD_OPTIONS } from '../constants'
import { PromotionCampaignFormData } from '../types'
import '../styles.scss'

type BasicInformationSectionProps = {
  campaign: PromotionCampaignFormData
  canEdit: boolean
  onChange: (campaign: PromotionCampaignFormData) => void
}

export const BasicInformationSection = ({
  campaign,
  canEdit,
  onChange,
}: BasicInformationSectionProps) => {
  const currentLimit = campaign.redemptionLimitFrequency?.limit ?? null
  const currentPeriod = campaign.redemptionLimitFrequency?.frequency ?? 'EVER'

  return (
    <Flex direction="column" gap="3">
      <Text size="3" weight="bold">
        Basic Information
      </Text>

      <Flex direction="column" gap="2">
        <Text size="2" weight="medium">
          Promotion Name
        </Text>
        <TextField.Root
          value={campaign.name}
          disabled={!canEdit}
          onChange={(e) => onChange({ ...campaign, name: e.target.value })}
        />
      </Flex>

      <Flex gap="3">
        <Flex direction="column" gap="2" style={{ flex: 1 }}>
          <Text size="2" weight="medium">
            Start Date
          </Text>
          <DateInput
            value={campaign.startAt ?? null}
            disabled={!canEdit}
            onChange={(date) => onChange({ ...campaign, startAt: date })}
          />
        </Flex>

        <Flex direction="column" gap="2" style={{ flex: 1 }}>
          <Text size="2" weight="medium">
            End Date
          </Text>
          <DateInput
            value={campaign.endAt ?? null}
            disabled={false}
            onChange={(date) => onChange({ ...campaign, endAt: date })}
          />
        </Flex>
      </Flex>

      <Flex gap="3">
        <Flex direction="column" gap="2" style={{ flex: 1 }}>
          <Text size="2" weight="medium">
            Redemption Limit
          </Text>
          <TextField.Root
            type="number"
            disabled={!canEdit}
            placeholder="Unlimited"
            value={currentLimit || ''}
            onChange={(e) => {
              const limit = e.target.value ? parseInt(e.target.value) : null
              onChange({
                ...campaign,
                redemptionLimitFrequency: limit ? { frequency: currentPeriod, limit } : null,
              })
            }}
          />
        </Flex>

        <Flex direction="column" gap="2" style={{ flex: 1 }}>
          <Text size="2" weight="medium">
            Limit Period
          </Text>
          <Select.Root
            disabled={!canEdit}
            value={currentPeriod}
            onValueChange={(value) => {
              const limit = currentLimit
              onChange({
                ...campaign,
                redemptionLimitFrequency: limit
                  ? { frequency: value as RedemptionLimitFrequencyPeriod, limit }
                  : null,
              })
            }}>
            <Select.Trigger />
            <Select.Content>
              {LIMIT_PERIOD_OPTIONS.map((option) => (
                <Select.Item key={option.value} value={option.value}>
                  {option.label}
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Root>
        </Flex>

        <Flex direction="column" gap="2" style={{ flex: 1 }}>
          <Text size="2" weight="medium">
            Type of Promotion
          </Text>
          <Text size="2" color="gray" className="promotion-type-display">
            Scan to Earn
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
